import { createAction } from '@reduxjs/toolkit';
import { AxiosResponseStatus } from './types';
import { JobLog } from '../../models/jobLog';
import { LogTag } from '../../models/logTags';

const tryFetchLogTagsStart = createAction('LOG_TAGS.TRY_FETCH.START');

const tryFetchLogTagsSuccess = createAction<LogTag[]>('LOG_TAGS.TRY_FETCH.SUCCESS');

const tryFetchLogTagsFailure = createAction<AxiosResponseStatus>('LOG_TAGS.TRY_FETCH.FAILURE');

export const logTagsActions = {
  tryFetchLogTagsStart,
  tryFetchLogTagsSuccess,
  tryFetchLogTagsFailure,
};
